import { useEffect } from "react";

// Faz o Enter avançar para o próximo campo/botão (como o Tab), em todo o sistema.
// Dropdowns (shadcn Select) e botões continuam com o comportamento normal do teclado.
const FOCUSABLE =
  'input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';

const isVisible = (el) => !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));

function focusNext(current) {
  const scope = current.closest('[role="dialog"]') || current.closest("form") || document.body;
  const nodes = Array.from(scope.querySelectorAll(FOCUSABLE)).filter((el) => el === current || isVisible(el));
  const idx = nodes.indexOf(current);
  if (idx === -1) return;
  const next = nodes[idx + 1];
  if (next) {
    next.focus();
    if (typeof next.select === "function") {
      try { next.select(); } catch (_) {}
    }
  }
}

export default function KeyboardNav() {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key !== "Enter" || e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) return;
      if (e.defaultPrevented || e.isComposing) return;
      const t = e.target;
      if (!t || !t.tagName) return;
      const tag = t.tagName;
      if (tag === "TEXTAREA" || tag === "BUTTON" || t.isContentEditable) return;
      const role = t.getAttribute && t.getAttribute("role");
      if (role === "combobox" || role === "menuitem" || role === "option") return;
      if (tag === "INPUT") {
        const type = (t.getAttribute("type") || "text").toLowerCase();
        if (["submit", "button", "checkbox", "radio", "file"].includes(type)) return;
      } else if (tag !== "SELECT") {
        return;
      }
      e.preventDefault();
      focusNext(t);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);
  return null;
}
